
import FileUploader from '../../../components/ui/FileUploader';
import { JSONValidator } from '../../../helper/Validators';

const FirebaseIntegrationsItem = ({ onFileRead, onFileUpload, firebaseData, onUploadName, onReadName, header, description, acceptedTypes, icon }) => {


    function shortenFilename(filename) {
        try {

            // Split the filename into name and extension
            const fileName = filename || ""
            const extensions = fileName.split(".")
            const fileExtension = fileName.split(".")[extensions?.length - 1]
            const fileNameWithoutExtension = fileName.replace(`.${fileExtension}`, "")

            // If the base name (without extension) is longer than 9 characters
            if (fileName.length > 15) {
                // Take the first 3 characters, add '...', then add the last 3 characters
                return `${fileNameWithoutExtension.slice(0, 6)}...${fileNameWithoutExtension.slice(-6)}.${fileExtension}`;
            }

            // If the filename is 9 characters or fewer, return it as is
            return fileName;
        }
        catch {
            return ""
        }
    }

    return (
        <>
            <div className="bg-white p-[20px] rounded-[10px] max-w-[1120px] w-[100%] h-[60pt] flex flex-row justify-between items-center"  >
                <div className='flex flex-row gap-[20px] items-center'>
                    {icon ||

                        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 217.56 273.25" width={"35"} height={"35"} className='m-[5px]'>
                            <defs>
                                <style>

                                    {`
                                                .cls-1 {
                                                    fill: #ff9100;
                                                }

                                                .cls-2 {
                                                    fill: #ffc400;
                                                }

                                                .cls-3 {
                                                    fill: #dd2c00;
                                                }
                                                    
                                                    `}
                                </style>
                            </defs>
                            <g id="Layer_1-2" data-name="Layer 1">
                                <g>
                                    <path class="cls-1" d="M68.14,265.4c11.43,4.6,23.84,7.33,36.86,7.79,17.63.62,34.39-3.03,49.37-9.95-17.97-7.06-34.24-17.38-48.13-30.22-9,14.42-22.32,25.8-38.1,32.38Z" />
                                    <path class="cls-2" d="M106.24,233.02c-31.71-29.32-50.94-71.76-49.31-118.31.05-1.51.13-3.02.23-4.53-5.68-1.47-11.61-2.36-17.71-2.58-8.73-.31-17.19.78-25.17,3.03C5.81,125.45.7,142.46.07,160.68c-1.64,47.02,26.81,88.11,68.07,104.72,15.78-6.58,29.1-17.96,38.1-32.38Z" />
                                    <path class="cls-1" d="M106.24,233.02c7.37-11.8,11.84-25.63,12.36-40.53,1.37-39.19-24.98-72.91-61.45-82.32-.09,1.51-.17,3.02-.23,4.53-1.63,46.55,17.61,88.99,49.31,118.31Z" />
                                    <path class="cls-3" d="M114.52,0c-20.77,16.64-37.17,38.58-47.09,63.85-5.68,14.48-9.25,30.03-10.29,46.33,36.47,9.41,62.82,43.12,61.45,82.32-.52,14.9-5,28.72-12.36,40.53,13.89,12.85,30.16,23.16,48.13,30.22,36.07-16.67,61.66-52.55,63.14-94.98.96-27.49-9.6-52-24.53-72.68C177.21,73.71,114.52,0,114.52,0Z" />
                                </g>
                            </g>
                        </svg>
                    }

                    <div className='flex flex-col gap-[4px]'>
                        <div className='text-bold text-[12pt] leading-[14.pt]'>
                            {header}
                        </div>
                        <div className='text-[9pt] leading-[14pt] text-[#667588] leading-[9.68px]'>
                            {description}
                        </div>

                    </div>
                </div>
                <div className='flex flex-row gap-[10px]'>
                    {firebaseData?.[onUploadName]?.name &&
                        <div className='flex flex-row gap-[12px] w-[170px] items-center'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="23" viewBox="0 0 13 16" fill="none">
                                <path d="M4.49813 8.6959H8.6959M4.49813 11.4944H6.59701M1 2.39925V13.5933C1 13.9644 1.14742 14.3203 1.40983 14.5827C1.67224 14.8451 2.02815 14.9925 2.39925 14.9925H10.7948C11.1659 14.9925 11.5218 14.8451 11.7842 14.5827C12.0466 14.3203 12.194 13.9644 12.194 13.5933V5.43703C12.194 5.25062 12.1567 5.0661 12.0844 4.89429C12.0121 4.72249 11.9062 4.56687 11.7729 4.43657L8.66651 1.39879C8.4051 1.14318 8.05404 1.00005 7.68843 1H2.39925C2.02815 1 1.67224 1.14742 1.40983 1.40983C1.14742 1.67224 1 2.02815 1 2.39925Z" stroke="#667588" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <div className='text-bold text-[9pt] leading-[14.pt] text-[#667588] leading-[9.68px]'>
                                {shortenFilename(firebaseData?.[onUploadName]?.name)}
                            </div>
                        </div>

                    }
                    <FileUploader acceptedTypes={acceptedTypes}
                        onFileUpload={(fileData) => {
                            onFileUpload?.(onUploadName, fileData)

                        }}
                        onFileRead={(fileData) => { onFileRead?.(onReadName, JSONValidator(fileData)) }} >

                    </FileUploader>
                </div>
            </div>
        </>
    );
};

export default FirebaseIntegrationsItem;
